import { useLanguageCode, useUserData } from 'hooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export default function useInitHomepage() {
  const dataUser = useUserData();
  const languageCode = useLanguageCode();
  const { isLoadingConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );

  useEffect(() => {
    if (!dataUser?.user_name || isLoadingConfig) return;
    window.scrollTo(0, 0);
    localStorage.setItem('IMAGE_USER_INFO', dataUser?.photo);
  }, [dataUser?.user_name, languageCode.snow, isLoadingConfig]);
}
